import { LuIcon, Menu, type MenuGroupProps } from "@overmap-ai/blocks"
import { OrganizationAccessLevel } from "@overmap-ai/common"
import { useNavigate } from "@tanstack/react-router"
import type { Geometry } from "geojson"
import { memo, useCallback } from "react"

import { useViewGeometryOnMap } from "../../mapbox/hooks"
import { modelIconMapping } from "../../mappings/icons"
import { OrganizationAccessRequired } from "../OrganizationAccessRequired/AccessRequired"

export interface GeometryGroupProps extends MenuGroupProps {
	onGeometryChange: () => void
	geometry: Geometry
}

export const GeometryGroup = memo<GeometryGroupProps>((props) => {
	const { ref, onGeometryChange, geometry, ...rest } = props

	const navigate = useNavigate()
	const viewGeometryOnMap = useViewGeometryOnMap()

	const handleViewLocationOnMap = useCallback(() => {
		void navigate({ from: "/$organizationId/$projectId", to: "/$organizationId/$projectId" }).then(() => {
			viewGeometryOnMap(geometry)
		})
	}, [geometry, navigate, viewGeometryOnMap])

	return (
		<Menu.Group ref={ref} {...rest}>
			<OrganizationAccessRequired accessLevel={OrganizationAccessLevel.BASIC} type="hide">
				<Menu.Item onSelect={handleViewLocationOnMap}>
					<LuIcon icon={modelIconMapping.expand} />
					View
				</Menu.Item>

				<Menu.Item onSelect={onGeometryChange}>
					<LuIcon icon={modelIconMapping.edit} />
					Edit
				</Menu.Item>
			</OrganizationAccessRequired>
		</Menu.Group>
	)
})
GeometryGroup.displayName = "GeometryGroup"
